/**
 * Masters Vuex Mutations
 * State modifications for the master tag import feature.
 */

export default {
  // === Batch Management ===
  SET_BATCHES(state, batches) {
    state.batches = batches;
  },

  SET_BATCHES_TOTAL(state, total) {
    state.batchesTotal = total;
  },

  SET_CURRENT_BATCH(state, batch) {
    state.currentBatch = batch;
  },

  SET_CURRENT_BATCH_TAGS(state, tags) {
    state.currentBatchTags = tags;
  },

  SET_CURRENT_BATCH_TAGS_TOTAL(state, total) {
    state.currentBatchTagsTotal = total;
  },

  ADD_BATCH(state, batch) {
    state.batches.unshift(batch);
    state.batchesTotal++;
  },

  REMOVE_BATCH(state, batchId) {
    state.batches = state.batches.filter(b => b.id !== batchId);
    state.batchesTotal = Math.max(0, state.batchesTotal - 1);
  },

  // === Loading States ===
  SET_LOADING(state, loading) {
    state.loading = loading;
  },

  SET_IMPORTING(state, importing) {
    state.importing = importing;
  },

  SET_DELETING(state, deleting) {
    state.deleting = deleting;
  },

  // === Error Handling ===
  SET_ERROR(state, error) {
    state.error = error;
  },

  CLEAR_ERROR(state) {
    state.error = null;
  },

  // === Upload Wizard State ===
  SET_WIZARD_OPEN(state, open) {
    state.wizardOpen = open;
  },

  SET_WIZARD_STEP(state, step) {
    state.wizardStep = step;
  },

  SET_SELECTED_TAG_TYPE(state, type) {
    state.selectedTagType = type;
  },

  SET_SELECTED_SCOPE_TYPE(state, type) {
    state.selectedScopeType = type;
  },

  SET_SELECTED_TARGET_ID(state, id) {
    state.selectedTargetId = id;
  },

  SET_BATCH_NAME(state, name) {
    state.batchName = name;
  },

  SET_PARSED_DATA(state, data) {
    state.parsedData = data;
  },

  SET_EXCEL_COLUMNS(state, columns) {
    state.excelColumns = columns;
  },

  SET_COLUMN_MAPPINGS(state, mappings) {
    state.columnMappings = mappings;
  },

  SET_CUSTOM_ATTRIBUTE_SELECTIONS(state, selections) {
    state.customAttributeSelections = selections;
  },

  SET_CUSTOM_DISPLAY_NAMES(state, names) {
    state.customDisplayNames = names;
  },

  SET_CUSTOM_DATA_TYPES(state, types) {
    state.customDataTypes = types;
  },

  SET_SOURCE_FILE_NAME(state, name) {
    state.sourceFileName = name;
  },

  // === Duplicate Check ===
  SET_DUPLICATE_CHECK_RESULT(state, result) {
    state.duplicateCheckResult = result;
  },

  SET_DUPLICATE_HANDLING(state, handling) {
    state.duplicateHandling = handling;
  },

  // === Background Job Tracking ===
  SET_PENDING_IMPORT_JOB(state, jobId) {
    state.pendingImportJob = jobId;
  },

  // === Import Result ===
  SET_IMPORT_RESULT(state, result) {
    state.importResult = result;
  },

  // === Import Progress (SSE streaming) ===
  SET_IMPORT_PROGRESS(state, progress) {
    state.importProgress = progress;
  },

  CLEAR_IMPORT_PROGRESS(state) {
    state.importProgress = null;
  },

  // === Pagination ===
  SET_OPTIONS(state, options) {
    state.options = { ...state.options, ...options };
  },

  // === Tags Dialog ===
  SET_TAGS_DIALOG_OPEN(state, open) {
    state.tagsDialogOpen = open;
  },

  // === Reset States ===
  RESET_WIZARD_STATE(state) {
    state.wizardStep = 1;
    state.selectedTagType = 'Equipment';
    state.selectedScopeType = 'Facility';
    state.selectedTargetId = null;
    state.batchName = '';
    state.parsedData = [];
    state.excelColumns = [];
    state.columnMappings = {};
    state.customAttributeSelections = {};
    state.customDisplayNames = {};
    state.customDataTypes = {};
    state.sourceFileName = '';
    state.duplicateCheckResult = null;
    state.duplicateHandling = 'Skip';
    state.pendingImportJob = null;
    state.importResult = null;
    state.importProgress = null;
    state.error = null;
  },

  RESET_BATCH_TAGS(state) {
    state.currentBatch = null;
    state.currentBatchTags = [];
    state.currentBatchTagsTotal = 0;
  },

  // === Schema Cache ===
  SET_SCHEMAS_CACHE(state, schemas) {
    state.schemasCache = schemas || {};
    state.schemasCacheLoaded = true;
  },

  CLEAR_SCHEMAS_CACHE(state) {
    state.schemasCache = {};
    state.schemasCacheLoaded = false;
  },

  // === API Data Source ===
  SET_API_DATA_SOURCES(state, dataSources) {
    state.apiDataSources = dataSources;
  },

  SET_API_DATA_SOURCES_TOTAL(state, total) {
    state.apiDataSourcesTotal = total;
  },

  SET_API_DATA_SOURCE_LOADING(state, loading) {
    state.apiDataSourceLoading = loading;
  },

  ADD_API_DATA_SOURCE(state, dataSource) {
    state.apiDataSources.push(dataSource);
  },

  UPDATE_API_DATA_SOURCE(state, updated) {
    const idx = state.apiDataSources.findIndex(ds => ds.id === updated.id);
    if (idx !== -1) {
      state.apiDataSources.splice(idx, 1, updated);
    }
  },

  REMOVE_API_DATA_SOURCE(state, id) {
    state.apiDataSources = state.apiDataSources.filter(ds => ds.id !== id);
  },

  // === Execution History ===
  SET_EXECUTION_HISTORY(state, history) {
    state.executionHistory = history;
  },

  SET_EXECUTION_HISTORY_TOTAL(state, total) {
    state.executionHistoryTotal = total;
  },

  SET_EXECUTION_HISTORY_LOADING(state, loading) {
    state.executionHistoryLoading = loading;
  },
};
